var map = {
	"./reset_S20c.png": 259,
	"./reset_S30c.png": 260,
	"./reset_allonePro.png": 261,
	"./reset_wifiLedStrip.png": 262,
	"./reset_xiaofang.png": 263,
	"./reset_xiaoyuan.png": 264,
	"./reset_zigbeeCurtainMoto.png": 763,
	"./reset_zigbeeMini.png": 764
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 984;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/connect ^\.\/reset_.*\.png$
// module id = 984
// module chunks = 1